/* eslint-disable @typescript-eslint/no-unused-vars */
import { connect } from "react-redux";
import Notification from "./index";
import { removeNotification } from "@/redux/slices/notification/NotificationSlice";
import { DialogChosenEnum } from "@/out-look/models/IDialogModel";
import { baContainer } from "@/ioc";
import { IBookingService, TokenIBookingService } from "@/services/booking-service";
import { CheckSuitableForMovingOrderEnum } from "@/services/order-service/entity/CheckSuitableForMovingOrderEnum";
import { IReservationTempService } from "@/services/reservationTemp-service/IReservationTempService";
import { ReservationTempService } from "@/services/reservationTemp-service/ReservationTempService";
import { IOrderService, TokenIOrderService } from "@/services/order-service/IOrderService";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { IOrganizationService, ResourceInfo, TokenIOrganizationService } from "@/services";
import { RcResourceService } from "@/services/rc-resource-service/RcResourceService";
import { OrderDataRequest } from "@/services/rc-resource-service/entity/OrderDataRequest";
import { IOutlookAppointmentService, TokenIOutlookAppointmentService } from "@/out-look/services";
import { CreateExternalTempReservationRequest } from "@/services/rc-resource-service/entity/request";
import { UidGenerator } from "@/shared/utilities/UidGenerator";
import { setResourceProcessingMoving } from "@/redux/slices/resources/ResourceSlice";

const mapDispatchToProps = (dispatch: any): any => {
  return {
    removeNotification: (guid: string) => dispatch(removeNotification(guid)),

    onDialogChoice: async (chosen: DialogChosenEnum, selectedResource: ResourceInfo[], settings: ISettingStore, orgStore: IOrganizationStore, guid: string) => {
      const orderService: IOrderService = baContainer.resolve(TokenIOrderService);
      const appointmentService: IOutlookAppointmentService = baContainer.resolve(TokenIOutlookAppointmentService);
      const organizerService: IOrganizationService = baContainer.resolve(TokenIOrganizationService);
      // const reservationTempService: IReservationTempService = new ReservationTempService();
      const movingOrderSession = orderService.MovingOrderSession;
      if (movingOrderSession) {
        switch (chosen) {
          case DialogChosenEnum.Yes: {
            const { SuitableEnum, ResourcesCalculated } = movingOrderSession;

            switch (SuitableEnum) {
              case CheckSuitableForMovingOrderEnum.PartialSuitable: {
                const response = await createExternalTempReservation(movingOrderSession, appointmentService, organizerService, orgStore);
                orderService.ShowPlaceOrderDialog(true, ResourcesCalculated.NewResource || new ResourceInfo(), selectedResource, [], settings, orgStore);
                dispatch(setResourceProcessingMoving([ResourcesCalculated.NewResource || new ResourceInfo()]));

                endMovingOrderSession(dispatch, false, guid);
                break;
              }

              case CheckSuitableForMovingOrderEnum.Deadline:
              case CheckSuitableForMovingOrderEnum.TotalSuitable: {
                if (ResourcesCalculated.NewResource && ResourcesCalculated.OldResource) {
                  const response = await createExternalTempReservation(movingOrderSession, appointmentService, organizerService, orgStore);
                  endMovingOrderSession(dispatch, true, guid);
                  dispatch(setResourceProcessingMoving([ResourcesCalculated.NewResource]));
                }
                break;
              }

              case CheckSuitableForMovingOrderEnum.DeadlineStopMoving:
                endMovingOrderSession(dispatch, true, guid);
                break;

              case CheckSuitableForMovingOrderEnum.Holiday:
                if (ResourcesCalculated.NewResource) {
                  endMovingOrderSession(dispatch, false, guid);
                }
                break;
            }
            break;
          }
          case DialogChosenEnum.No:
            if (movingOrderSession.ResourcesCalculated.NewResource) {
              // clear temp moving order.
              // reservationTempService.DeleteMovingOrderTemp({
              //   NewResourceId: movingOrderSession.ResourcesCalculated.NewResource.Id,
              // });
              endMovingOrderSession(dispatch, false, guid);
              if (movingOrderSession.SuitableEnum === CheckSuitableForMovingOrderEnum.Deadline || movingOrderSession.SuitableEnum === CheckSuitableForMovingOrderEnum.TotalSuitable) {
                orderService.ShowPlaceOrderDialog(true, movingOrderSession.ResourcesCalculated.NewResource, selectedResource, [], settings, orgStore);
              }
            }
            break;
          case DialogChosenEnum.ViewOrder:
            // view order detail dialog.
            const { ResourcesCalculated } = movingOrderSession;

            if (ResourcesCalculated.OldResource) {
              orderService.ShowViewOrderDialog(selectedResource, ResourcesCalculated.OldResource, settings, orgStore);
            }
            break;
        }
      }
    },
    OnClose: function (guid: string) {
      //   const bookingService: IBookingService = baContainer.resolve(TokenIBookingService);
      //   const reservationTempService: IReservationTempService = new ReservationTempService();
      //   const movingOrderSession = bookingService.MovingOrderSession;
      //   if (movingOrderSession && movingOrderSession.ResourcesCalculated.NewResource) {
      //     reservationTempService.DeleteMovingOrderTemp({
      //       NewResourceId: movingOrderSession.ResourcesCalculated.NewResource.Id,
      //     });
      //   }
      endMovingOrderSession(dispatch, false, guid);
    },
  };
};

//Hàm tắt thông báo
const endMovingOrderSession = (dispatch: any, ys: any, guid: string) => {
  const orderService: IOrderService = baContainer.resolve(TokenIOrderService);
  dispatch(removeNotification(guid));
  if (ys) {
    // dispatch(SelectedResourceListActionCreator.DisablePlaceOrderDueToMoving());
  }
  orderService.ReleaseMovingOrderSession();
};

// Tách logic tạo external temp reservation thành hàm riêng
const createExternalTempReservation = async (movingOrderSession: any, appointmentService: IOutlookAppointmentService, organizerService: IOrganizationService, orgStore: IOrganizationStore) => {
  const currentAppointment = appointmentService.GetCurrentAppointment();
  const organizer = await organizerService.GetCurrentOrganizer();
  const rcResourceService = new RcResourceService();

  const iCalUid =
    orgStore.orgInfo?.iCalUIds?.find((item) => item.adId === movingOrderSession.ResourcesCalculated.OldResource?.adId)?.iCalUids[0] || movingOrderSession.ResourcesCalculated.OldResource?.uuid;

  const payLoadApi: CreateExternalTempReservationRequest = {
    OrganizerEmail: organizer?.Email || "",
    ResourceAdId: movingOrderSession.ResourcesCalculated?.NewResource?.adId || "",
    StartTime: currentAppointment?.StartTimeTicks ?? 0,
    EndTime: currentAppointment?.EndTimeTicks ?? 0,
    IsRecurring: currentAppointment?.IsRecurringMaster || false,
    TimeZoneCode: organizer?.TimeZoneStandardName || "",
    CustomUid: movingOrderSession.ResourcesCalculated?.NewResource?.uuid || "",
    OldGuid: iCalUid || "",
  };

  const baseUrl = orgStore.orgInfo?.resourceCentralEndpoint ?? "";
  const payload: OrderDataRequest = {
    BaseUrl: `${baseUrl}/ResourceCentral/api/OfficeApp/CreateExtenalTempReservationForMovingOrder`,
    Payload: payLoadApi,
  };

  return await rcResourceService.fetchCreateExternalTempReservation(payload);
};

export default connect(null, mapDispatchToProps)(Notification);
